@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.controlGroup {
  position: absolute;
  overflow: hidden;
  display: flex;
  align-items: center;
  z-index: 1;
  top: 5px;
  right: 6px;
  border-radius: 6px;
  border: none;
  background: var(--light-100);
  box-shadow: 0 2px 8px 0 var(--dark-7);
  @include blur;

  [data-autopilot-system-redesign='on'] & {
    @include blur(0);
    box-shadow: none;
    border: 1px solid var(--dark-8);
  }

  button {
    color: var(--dark-80);

    div {
      width: 20px !important;
      height: 20px !important;
    }
  }

  @include for-phone-only {
    background: none;
    box-shadow: none;
    backdrop-filter: none;
  }
}
